// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"2c6716e8","707":"381f8b96","729":"3498823d"}[chunkId] + ".js";
};